import { render, staticRenderFns } from "./EconomicPerformanceModal.vue?vue&type=template&id=4bcb9b64"
import script from "./EconomicPerformanceModal.vue?vue&type=script&lang=js"
export * from "./EconomicPerformanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports